
export default class properties {

    static recaptcha_sitekey="6LfZrBglAAAAAFmtMRICQhNMOEas8WfOFzMlIbgs";

}